import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=20f6a79c&lang=pug&"
import script from "./CompanyPage.vue?vue&type=script&lang=js&"
export * from "./CompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports